import Client from "../client";
import ConfigurationRepository from "./configurationRepository";
import PerformanceConfigurationResource from "../resources/PerformanceConfigurationResource";

class PerformanceConfigurationRepository extends ConfigurationRepository<PerformanceConfigurationResource> {
    constructor(client: Client) {
        super("PerformanceConfiguration", client);
    }
}

export default PerformanceConfigurationRepository;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/repositories/performanceConfigurationRepository.ts